<template>
<!-- ユーザ登録画面 -->
<CCard>
  <CCardHeader>
    <a name="/users/register"></a>
    <h2>ユーザ登録</h2>
  </CCardHeader>
  <CCardBody>
    <p><span class="asterisk">*</span>が付いている項目は必須入力項目です</p>
    <ValidationObserver ref="obs" v-slot="ObserverProps">
      <CRow v-if="message.length">
        <ul>
          <li style="color: red;" v-for="error in message" :key="error">{{ error }}</li>
        </ul>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='社員番号' rules="employee|max:20" v-slot="ProviderProps">
            <CInput label="社員番号" v-model="employee" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='氏名' rules="required|name:20" v-slot="ProviderProps">
            <label>氏名<span class="asterisk">*</span></label>
            <CInput v-model="name" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='電話番号' rules="tel" v-slot="ProviderProps">
            <CInput label="電話番号" v-model="telephone" description="ハイフンなしで入力してください" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='住所' rules="address|max:60" v-slot="ProviderProps">
            <CInput label="住所" v-model="address" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='E-Mail' rules="required|email|max:254" v-slot="ProviderProps">
            <label>E-Mail<span class="asterisk">*</span></label>
            <CInput v-model="email" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='E-Mail(確認)' rules="required|email|max:254|check:E-Mail" v-slot="ProviderProps">
            <label>E-Mail(確認)<span class="asterisk">*</span></label>
            <CInput v-model="re_mail" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='パスワード' rules="required|password" v-slot="ProviderProps">
            <label>パスワード<span class="asterisk">*</span></label>
            <CInput type="password" id="pass" v-model="password" description="英数字混在で8文字以上20文字以下で入力してください。記号の入力も可能です。" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='パスワード(確認)' rules="required|password|check:パスワード" v-slot="ProviderProps">
            <label>パスワード(確認)<span class="asterisk">*</span></label>
            <CInput type="password" v-model="re_password" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <label>ユーザ種別<span class="asterisk">*</span></label>
          <ValidationProvider name='ユーザ種別' rules="select" v-slot="ProviderProps">
            <select class="custom-select" v-model="type">
              <option disabled value="">選択してください</option>
              <option v-for="option in options" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
      <CCol sm="3">
        <div class="d-flex align-items-center">
          <label class="custom-switch mb-0">
            <input
              type="checkbox"
              class="custom-switch-input"
              id="approver-flg"
              v-model="approver_flg"
            />
            <span class="custom-switch-indicator" aria-hidden="true"></span>
          </label>
          <label for="approver-flg" class="ml-2 mb-0">申請承認者</label>
        </div>
      </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>有給日数</label>
          <ValidationProvider name='有給日数' rules="holiday|min:-99.9|max:99.9" v-slot="ProviderProps">
            <CInput v-model="paid" placeholder="10.0" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>代休日数</label>
          <ValidationProvider name='代休日数' rules="holiday|min:-99.9|max:99.9" v-slot="ProviderProps">
            <CInput v-model="comp" placeholder="10.0" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>固定内残業</label>
          <ValidationProvider name='固定内残業' rules="total_time" v-slot="ProviderProps">
            <CInput v-model="fixed_over_time" placeholder="00:00" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>Slack ID</label>
          <ValidationProvider name='Slack ID' rules="max:20" v-slot="ProviderProps">
            <CInput v-model="slack_id" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <br>
      <CRow class="mt-3 align-items-center">
        <!-- 左寄せ：戻る -->
        <CCol class="text-start">
          <button class="btn btn-secondary btn-sm" @click="valueCheck">戻る</button>
        </CCol>
        <!-- 横並び：確認 -->
        <CCol class="text-center">
          <button v-on:click="openModal" class="btn btn-info" :disabled="ObserverProps.invalid">確認</button>
          <!-- 登録確認モーダルコンポーネント呼出 -->
          <RegisterModal 
            :draggable="true" 
            :resizable="true" 
            :employee="employee" 
            :user="name" 
            :tel="telephone" 
            :live="address" 
            :mail="email" 
            :pass="hide" 
            :select="type_name" 
            :approver_flg="approver_flg" 
            :paid="paid" 
            :comp="comp" 
            :fixed_over_time="fixed_over_time" 
            :slack_id="slack_id" 
            :authorized="authorized" 
            :loading="loading"
            v-show="showModal" 
            @register="register" 
            @close="closeModal">
          </RegisterModal>
        </CCol>
        <!-- 空白スペース用 -->
        <CCol ></CCol>
      </CRow>
    </ValidationObserver>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import RegisterModal from './RegisterModal'
import axios from 'axios'
export default {
  name: 'RegisterInput',
  components: {
    RegisterModal
  },
  data() {
    return {
      showModal: false,
      employee: '',
      name: '',
      telephone: '',
      address: '',
      email: '',
      re_mail: '',
      password: '',
      re_password: '',
      type: '',
      approver_flg: false,
      paid: '',
      comp: '',
      fixed_over_time: '',
      slack_id: '',
      options: [],
      type_name: '',
      hide: '',
      message: [],
      authorized: false,
      list: '',
      registerTop: '',
      loading: false
    }
  },

  created() {
        this.list = ConstList.ROUTE_LIST;
        this.registerTop = ConstList.REGISTER_TOP
      },

    // DBから各種情報を取得
  mounted: function () {
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/users/authority')
        .then(response => {
          if (response.data.length === 0) {
            this.errors.push(ConstList.EMPTY)
          }
            this.options = response.data
                    })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
  },
  methods: {
    // ユーザ管理へ遷移する際の入力値チェック
    valueCheck: function () {
      if ((this.employee) || (this.name) || (this.telephone) || (this.address) || (this.email) || (this.re_mail) || (this.password) || (this.re_password) || (this.type) || (this.approver_flg) || (this.paid) || (this.comp) || (this.fixed_over_time) || (this.slack_id)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({ 
            name: this.list
          });
        }
      } else {
        this.$router.push({ 
            name: this.list
          });
      }
    },
    // モーダルを表示
    openModal: function () {
      this.hide = ConstList.ASTERISK.repeat(this.password.length);
      const userType = this.options.find(({id}) => id === this.type);
      this.type_name = userType.name
      this.showModal = true
    },
    // 登録内容を送信
    register: function () {
      this.loading = true;
      const params = new URLSearchParams()
      params.append(ConstList.EMPLOYEE_ID, this.employee)
      params.append(ConstList.NAME, this.name)
      params.append(ConstList.TELEPHONE, this.telephone)
      params.append(ConstList.ADDRESS, this.address)
      params.append(ConstList.EMAIL, this.email)
      params.append(ConstList.PASSWORD, this.password)
      params.append(ConstList.AUTHORITY_ID, this.type)
      params.append(ConstList.APPROVER_FLG, this.approver_flg)
      params.append(ConstList.DELETED_FLG, ConstList.REMAIN)
      params.append(ConstList.PAID_DAYS, Number(this.paid))
      params.append(ConstList.COMP_DAYS, Number(this.comp))
      params.append(ConstList.FIXED_OVER_TIME, this.fixed_over_time)
      params.append(ConstList.SLACK_ID, this.slack_id)
      
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/users/register', params)
        .then(response => {          
          if (response.data === ConstList.SUCCESS) {
            this.authorized = true
            alert(ConstList.REGISTER_MESSAGE)
            this.$router.push({ 
              name: this.list
            });
            
          } else {
            
            this.message[0] = response.data
            this.showModal = false
            this.$router.push({ 
              name: this.registerTop
            });
            
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false
      location.hash = ConstList.REGISTER_TOP
    },
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.asterisk {
  color: red;
}
</style>
